import React, { Component } from "react";
import '../../../../../Assets/EnsembleStyles/EnsNav.css';
 import { Navbar, NavbarBrand } from 'reactstrap';
import NavbarLogo from '../../../../../Assets/images/green-trane-BA-logo.svg';


export default class Navigationheader extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
          isOpen: false
        };
      }
      toggle() {
        this.setState({
          isOpen: !this.state.isOpen
        });
      }
    render() {
        return (
            <div className="Navigation_Grid">
            <Navbar  className={"Ensemble_Navbackground"} fixed={`top`} light expand="md">
            <NavbarBrand className="Ensemble_mainTitle" >
          <img src={NavbarLogo} alt="Trane Logo" className="Ensemble_trane_logo"/>
          </NavbarBrand>
        </Navbar> 

        <Navbar  className={"Ensemble_Navbackground Ensemble_login_language_Navbackground"}  light expand="md">
        

          {/* <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
          <Nav  navbar>
              <NavItem><NavLink href="/"> English</NavLink></NavItem>
              <NavItem><NavLink href="/"> français</NavLink></NavItem>
              <NavItem><NavLink href="/"> español</NavLink></NavItem>
              <NavItem><NavLink href="/"> Deutsch</NavLink></NavItem>
              <NavItem><NavLink href="/"> 中文(简体) 旧版</NavLink></NavItem>
              <NavItem><NavLink href="/"> العربية</NavLink></NavItem>
              <NavItem><NavLink href="/"> Bahasa Indonesia</NavLink></NavItem>
              <NavItem><NavLink href="/"> 日本語</NavLink></NavItem>
              <NavItem><NavLink href="/"> 한국어</NavLink></NavItem>
              <NavItem><NavLink href="/"> português</NavLink></NavItem>
              <NavItem><NavLink href="/"> ไทย</NavLink></NavItem>
              <NavItem><NavLink href="/"> 中文(繁體) 舊版</NavLink></NavItem>
           
            </Nav>
          
          </Collapse> */}
        </Navbar> 

          </div>

        );
    }
}


